module.exports = __webpack_public_path__ + "files/a82898eb0fa6bb64021804cb5531ef69.svg";